import { useRef } from "react"
import "../marketing.css"
import { GoHeader } from "./GoHeader"
import { GoStorySection } from "./GoStorySection"
import { GoFeaturesSection } from "./GoFeaturesSection"
import { GoVideoSection } from "./GoVideoSection"
import { GoPricingSection } from "./GoPricingSection"
import { GoAllInOneSection } from "./GoAllInOneSection"
import { GoPressSection } from "./GoPressSection"
import { GoTestimonialsSection } from "./GoTestimonialsSection"
import { GoHeroSection } from "./GoHeroSection"
import { GoCrossPlatformSection } from "./GoCrossPlatformSection"
import { MarketingNavigation } from "../components/MarketingNavigation"
import { MarketingBackgroundVector } from "../components/MarketingBackgroundVector"

export function GoMarketingPage() {
  const videoRef = useRef<HTMLDivElement>(null)

  const scrollToVideo = () => {
    videoRef.current?.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <div className="mk-page">
      <div className="mk-header">
        <MarketingBackgroundVector />
        <div className="mk-header-content">
          <MarketingNavigation activePage="Go" />
          <GoHeader scrollToVideo={scrollToVideo} />
        </div>
      </div>
      <GoStorySection />
      <GoFeaturesSection />
      <div ref={videoRef}>
        <GoVideoSection />
      </div>
      <GoPricingSection />
      <GoAllInOneSection />
      <GoPressSection />
      <GoTestimonialsSection />
      <GoHeroSection scrollToVideo={scrollToVideo} />
      <GoCrossPlatformSection />
    </div>
  )
}
